import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loyaltyUser: null,
  loyaltyMerchantTheme: null,
  cartItems: [],
  cartDrawerOpen: false,
  orderDetails: null,
  // Payment-related state
  transactionCharge: null,
  processPaymentData: null,
  processError: null,
  paymentSuccess: false,
  startCheck: false,
  statusCheckText: "",
  trackDataToPost: null,
  verificationData: null,
  merchantRewards: [],
  customerWallets: [],
  activePayments: [],
  paymentWallets: [],
  loading: false,
};

const loyaltySlice = createSlice({
  name: "loyalty",
  initialState,
  reducers: {
    setLoyaltyUser(state, action) {
      state.loyaltyUser = action.payload;
    },
    setLoyaltyMerchantTheme(state, action) {
      state.loyaltyMerchantTheme = action.payload;
    },
    addToCart(state, action) {
      const item = action.payload;
      const existing = state.cartItems.find((i) => i.id === item.id);
      if (existing) {
        existing.quantity += item.quantity || 1;
      } else {
        state.cartItems.push({ ...item, quantity: item.quantity || 1 });
      }
    },
    removeFromCart(state, action) {
      state.cartItems = state.cartItems.filter((i) => i.id !== action.payload);
    },
    updateCartItemQuantity(state, action) {
      const { id, quantity } = action.payload;
      const item = state.cartItems.find((i) => i.id === id);
      if (item) {
        item.quantity = quantity;
      }
    },
    updateCartItem(state, action) {
      const { id, item } = action.payload;
      const idx = state.cartItems.findIndex((i) => i.id === id);
      if (idx !== -1) {
        state.cartItems[idx] = { ...item };
      }
    },
    clearCart(state) {
      state.cartItems = [];
    },
    openCartDrawer(state) {
      state.cartDrawerOpen = true;
    },
    closeCartDrawer(state) {
      state.cartDrawerOpen = false;
    },
    setOrderDetails: (state, action) => {
      state.orderDetails = action.payload;
    },
    // Payment-related reducers
    setTransactionCharge(state, action) {
      state.transactionCharge = action.payload;
    },
    setProcessPaymentData(state, action) {
      state.processPaymentData = action.payload;
    },
    setProcessError(state, action) {
      state.processError = action.payload;
    },
    setPaymentSuccess(state, action) {
      state.paymentSuccess = action.payload;
    },
    setStartCheck(state, action) {
      state.startCheck = action.payload;
    },
    setStatusCheckText(state, action) {
      state.statusCheckText = action.payload;
    },
    setTrackDataToPost(state, action) {
      state.trackDataToPost = action.payload;
    },
    setVerificationData(state, action) {
      state.verificationData = action.payload;
    },
    setMerchantRewards(state, action) {
      state.merchantRewards = action.payload;
    },
    setCustomerWallets(state, action) {
      state.customerWallets = action.payload;
    },
    setActivePayments(state, action) {
      state.activePayments = action.payload;
    },
    setPaymentWallets(state, action) {
      state.paymentWallets = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    resetPaymentState(state) {
      state.transactionCharge = null;
      state.processPaymentData = null;
      state.processError = null;
      state.paymentSuccess = false;
      state.startCheck = false;
      state.statusCheckText = "";
      state.trackDataToPost = null;
      state.verificationData = null;
      state.merchantRewards = [];
      state.paymentWallets = [];
      state.loading = false;
    },
  },
});

export const {
  setLoyaltyUser,
  setLoyaltyMerchantTheme,
  addToCart,
  removeFromCart,
  updateCartItemQuantity,
  clearCart,
  openCartDrawer,
  closeCartDrawer,
  setOrderDetails,
  updateCartItem,
  // Payment-related actions
  setTransactionCharge,
  setProcessPaymentData,
  setProcessError,
  setPaymentSuccess,
  setStartCheck,
  setStatusCheckText,
  setTrackDataToPost,
  setVerificationData,
  setMerchantRewards,
  setCustomerWallets,
  setActivePayments,
  setPaymentWallets,
  setLoading,
  resetPaymentState,
} = loyaltySlice.actions;
export default loyaltySlice.reducer;
